import { hubConstants } from "../constants";

// Hub embeds the app by adding these elements to its own page.
export const getHubElements = () => ({
  hubRootElement: document.getElementById(hubConstants.HUB_ROOT_ELEMENT_ID),
  hubImagePathElement: document.getElementById(
    hubConstants.HUB_IMAGE_PATH_ELEMENT_ID
  ),
});
